<script setup>
const metadata = useMetadata()
</script>

<template>
  <a :href="`mailto:${metadata?.customerService?.email}`">
    {{ metadata?.customerService?.email }}
  </a>
</template>
